import React, {useState, useRef} from "react";
import Slider from "react-slick";
import Styles from './styles.module.scss';

import arrowL from '../../../theme/assets/svg/lp_cabinet_slider_arrow_l.svg';
import arrowR from '../../../theme/assets/svg/lp_cabinet_slider_arrow_r.svg';

const getYoutubeId = (url) => {
    const match = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
    return match ? match[1] : null;
};

const getYoutubeEmbedUrl = (url) => {
    const id = getYoutubeId(url);
    return id ? `https://www.youtube.com/embed/${id}` : url;
};

const getYoutubeThumbnail = (url) => {
    const id = getYoutubeId(url);
    return id ? `https://img.youtube.com/vi/${id}/0.jpg` : null;
};

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <div className={Styles.arrowNext} onClick={onClick}>
            <img src={arrowR} alt="arrow"/>
        </div>
    );
};

const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className={Styles.arrowPrev} onClick={onClick}>
            <img src={arrowL} alt="arrow"/>
        </div>
    );
};

const MediaSlider = ({ media = [] }) => {
    const sliderRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);

    const handlePreviewClick = (index) => {
        setActiveIndex(index);
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(index);
        }
    };

    const settings = {
        infinite: true,
        speed: 500, // ← длительность анимации (мс)
        cssEase: "ease-in-out", // ← тип анимации (можно linear, ease, cubic-bezier)
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        beforeChange: (_, next) => setActiveIndex(next),
        dots: false,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    return (
        <div className={Styles.sliderWrapperOuter}>
            <div className={Styles.wrapper}>
                <div className={Styles.sliderBox}>
                    <Slider ref={sliderRef} {...settings}>
                        {media.map((item, index) => (
                            <div key={index} className={Styles.sliderItem}>
                                {item.type === "image" ? (
                                    <img src={item.url} alt={`media-${index}`} className={Styles.media} />
                                ) : (
                                    <iframe
                                        src={getYoutubeEmbedUrl(item.url)}
                                        title={`video-${index}`}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        className={Styles.media}
                                    />
                                )}
                            </div>
                        ))}
                    </Slider>
                </div>

                <div className={Styles.previewRow}>
                    {media.map((item, index) => {
                        const isActive = index === activeIndex;
                        const thumbUrl = item.type === "image" ? item.url : getYoutubeThumbnail(item.url);

                        return (
                            <div
                                key={index}
                                className={`${Styles.previewItem} ${isActive ? Styles.active : ""}`}
                                onClick={() => handlePreviewClick(index)}
                            >
                                <img src={thumbUrl} alt={`thumb-${index}`} />
                                {item.type === "video" && <div className={Styles.playIcon}>▶</div>}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>

    );
};

export default MediaSlider;